var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1 16C3.1 8.93075 8.65167 3.2 15.5 3.2C22.3484 3.2 27.9 8.93075 27.9 16C27.9 22.5274 23.1668 27.9136 17.05 28.701V19.2H20.15C21.0061 19.2 21.7 18.4837 21.7 17.6C21.7 16.7163 21.0061 16 20.15 16H17.05V12.8C17.05 11.9164 17.7439 11.2 18.6 11.2H19.375C20.2311 11.2 20.925 10.4836 20.925 9.6C20.925 8.71635 20.2311 8 19.375 8H18.6C16.0318 8 13.95 10.149 13.95 12.8V16H10.85C9.99397 16 9.3 16.7163 9.3 17.6C9.3 18.4837 9.99397 19.2 10.85 19.2H13.95V28.701C7.83322 27.9136 3.1 22.5274 3.1 16ZM15.5 32C24.0603 32 31 24.8365 31 16C31 7.16344 24.0603 0 15.5 0C6.93958 0 0 7.16344 0 16C0 24.8365 6.93958 32 15.5 32Z",
    fill: "#01AB6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookicon);
export default __webpack_public_path__ + "static/media/facebookicon.14e2b4a40f40fdad4dd6487572bf56cf.svg";
export { ForwardRef as ReactComponent };